import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

type TUseMoveGoalBreakdownChallengesMutation = {
  options?: any;
};

export const useMoveGoalBreakdownChallengesMutation = ({
  options,
}: TUseMoveGoalBreakdownChallengesMutation) => {
  const { goalId } = useParams();
  const { request } = useMutationHTTPRequest();

  return useMutation(
    ({
      customChallengeId,
      index,
      focusAreaId,
    }: {
      customChallengeId: string;
      index: number;
      focusAreaId?: string;
    }) =>
      request({
        url: `/api/web/goals/${goalId}/breakdown/challenges/move`,
        body: { challengeId: customChallengeId, focusAreaId, index },
      }),
    {
      ...options,
    }
  );
};
